import clsx from "clsx";

export const UiTitle = ({
  text,
  className,
}: {
  text?: string;
  className?: string;
}) => {
  return (
    <h2
      className={clsx(
        "text-[18px] sm:text-[1.5rem] font-semibold leading-[1.875rem] text-[#232323]",
        className,
      )}
    >
      {text}
    </h2>
  );
};

export const UiSubTitle = ({
  text,
  className,
}: {
  text?: string;
  className?: string;
}) => {
  return (
    <h3
      className={clsx(
        "text-[1.25rem] font-semibold leading-[1.625rem] text-[#232323]",
        className,
      )}
    >
      {text}
    </h3>
  );
};

export const UiH4 = ({
  text,
  className,
}: {
  text?: string;
  className?: string;
}) => {
  return (
    <h4
      className={clsx(
        "text-sm font-semibold leading-[1.5rem] text-gray-900 sm:text-[1.875rem] sm:text-lg sm:leading-[1.75rem]",
        className,
      )}
    >
      {text}
    </h4>
  );
};
